<template>
  <div id="app" :class="{ dark: $store.state.dark }">
    <preloader/>
    <div class="background">
      <!-- <lines></lines> -->
      <animated-lines></animated-lines>
    </div>
    <router-link class="logo anime" to="/"><img alt="سمة" src="@/assets/logo.svg"></router-link>
    <div class="hamburger anime">
      <div class="hamburger__inner">
        <span class="hamburger-line"></span>
        <span class="hamburger-line"></span>
        <span class="hamburger-line"></span>
      </div>
    </div>
    <div class="content"><router-view/></div>
  </div>
</template>

<script>
import Preloader from '@/components/Preloader.vue'
import AnimatedLines from '@/components/AnimatedLines'

export default {
  name: 'SimahAgency',
  components: {
    Preloader,
    AnimatedLines
  },
  mounted () {
    const self = this
    document.querySelector('html').style.overflow = 'hidden'

    const tl = self.$anime.timeline({
      easing: 'linear'
    })

    self.$eventBus.$on('PAGE_LOADED', () => {
      const targets = '.anime'

      tl.add({
        targets,
        duration: 300,
        opacity: [0, 1],
        translateY: [-250, 0],
        easing: 'easeOutExpo'
      })

      document.querySelector('html').style.overflow = 'auto'

      // tl.add({
      //   targets: '.background',
      //   width: [0, '100%'],
      //   easing: 'easeInOutSine',
      //   duration: 1500
      // })

      // tl.add({
      //   targets: '.background',
      //   keyframes: [
      //     { width: '100%', right: '100%', maskPosition: 'left' },
      //     { width: 0, right: '0%', maskPosition: 'right' }
      //     // { width: 0 }
      //   ],
      //   duration: 3000,
      //   // direction: 'alternate',
      //   easing: 'easeInExpo',
      //   loop: true
      // })
    })
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Cairo');

html {
  box-sizing: border-box;
  font-size: 12px;
  direction: rtl;
  letter-spacing: -1px;
  @media screen and (min-width: 640px) {
    font-size: calc(12px + 8*(100vw - 640px)/3200);
  }
}

*, *:before, *:after {
  box-sizing: inherit;
}

::-webkit-scrollbar {
  width: 3px;
}

/* Track */
::-webkit-scrollbar-track {
  background: transparent;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #ffffff;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  cursor: pointer;
}

body, h1, h2, h3, h4, h5, h6, p, ol, ul {
  margin: 0;
  padding: 0;
  font-weight: normal;
}

h1, h2, h3, h4, h5, h6 {
  margin-bottom: 1rem;
  font-weight: 600;
}

h1 {
  font-size: 5.5rem;
}

h2 {
  font-size: 3.5rem;
}

h3 {
  font-size: 3rem;
}

h4 {
  font-size: 2.25rem;
}

h5 {
  font-size: 1.75rem;
}

h6 {
  font-size: 1.125rem;
}

ol, ul {
  list-style: none;
}

a {
  color: inherit;
  text-decoration: none;
}

.text-white {
  color: white;
}

img {
  max-width: 100%;
  height: auto;
}

.background {
  position: fixed;
  z-index: 0;
  pointer-events: none;
  width: 101%;
  top: 0;
  left: 0;
  height: 100%;
  // opacity: .5;
  // background: linear-gradient(to right, #ffffff, #38183D, #ffffff);
  // mask: url('data:image/svg+xml;utf8,<svg id="lines" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" viewBox="0 0 1366 768"><path class="cls-1" d="M-8.08,794.42C43.37,780.17,95.65,770.5,148.6,764c50.54-6.22,101.92-10.32,152.79-6,51.81,4.37,103.7,12.86,152.48,31.32,47.79,18.09,93.33,43.84,137.53,69.37a1241.28,1241.28,0,0,1,133.22,89.41c31.4,24,61.49,49.53,92.46,74.07,76,60.22,155.4,116.08,243.73,156.86a903.33,903.33,0,0,0,288.91,78.84c10.45,1,20.92,1.89,31.4,2.64,3.18.22,6.62.86,9.8.63-.36,0-4.32-.4-5.55-.49-102.91-7.33-204.57-33.91-298.67-76-91.32-40.83-173-97.72-251.26-159.46-31.57-24.91-62.15-51-94.1-75.39a1244.85,1244.85,0,0,0-136-91.17c-45.49-26.15-92.32-52.66-141.75-70.51C416.3,771,366.39,763.4,316.49,759c-101.43-9.06-204.42,1.29-303.37,24.79Q-5.54,788.17-24,793.31c4.8-1.33,11.06,2.46,15.93,1.11Z"/><path class="cls-1" d="M-8.08,742.34A1826.36,1826.36,0,0,1,292.32,704c102-4.49,204.84,5.07,303.92,30.22a827,827,0,0,1,88.32,28.29C736.11,782,787.19,802.6,837.38,825.35c44.85,20.32,89.32,41.81,132.51,65.47,28.17,15.44,56,31.37,84.47,46.36,91.8,48.4,184.88,93.87,281,133.17q21.27,8.7,42.69,17.05c4.77,1.86,11.24-.72,15.94,1.11-102.51-40-201.9-86.58-299.41-137.5q-50.31-26.28-99.7-54.06C954.54,874.38,912.93,854,871,834.58c-52.66-24.41-106.3-46.38-160.49-67.13-31.55-12.08-63.43-23.14-96.17-31.55-94.08-24.16-192.6-34.41-289.61-34.16-48.51.13-96.82,3.84-145.09,8.34q-85.5,8-169.93,24.27-16.9,3.27-33.75,6.88c5-1.06,10.9,2.19,15.93,1.11Z"/><path class="cls-1" d="M1391.21,1019.58c-85.13-23.88-168.66-52.18-251.09-84-76.93-29.74-153.64-60.06-230.6-89.71-87.26-33.6-174.22-68.33-264.71-92.46C541.75,725.89,433.54,715.24,327,718.09,216.68,721,106.94,737.8-.83,761.11q-11.61,2.5-23.18,5.14c4.94-1.12,10.93,2.25,15.93,1.11,103.36-23.43,208.78-41.28,314.72-46.71,105.68-5.41,211.12,3,313.73,29.38C707.49,772.47,791.14,805.3,875,837.55c76.29,29.36,152.35,59.31,228.57,88.87,74.26,28.8,148.92,55.77,225.29,78.6q23.17,6.93,46.46,13.45c5,1.41,10.93-.29,15.93,1.11Z"/><path class="cls-1" d="M1391.21,894.49c-98.44-28.78-194.49-64.3-288.71-104.69q-78.57-33.69-157.64-66.15c-36.25-14.95-72.59-29.79-109.57-42.86-45.43-16.07-91.29-31.37-137.9-43.67a932.8,932.8,0,0,0-170-28.44c-86.81-6.35-173.55-3.91-259,13.58C182,639.92,95.8,658.09,9.54,676L-24,683c5-1,10.89,2.17,15.93,1.12,91.13-19,182.35-37.61,273.44-56.82,27.36-5.76,54.71-11,82.48-14.52,48.62-6.11,97.61-7.54,146.55-5.68,58.57,2.23,116.54,11.2,173.38,25.37,47.87,11.94,94.66,27.58,141.29,43.59,34.2,11.75,67.82,25.15,101.29,38.83q77.24,31.56,154,64.28c91.81,39.11,184.27,75.56,279.77,104.87q15.54,4.77,31.14,9.32c5,1.47,11-.34,15.93,1.11Z"/><path class="cls-1" d="M-8.08,677c92.78-27.78,187.13-51.26,282.67-67.29,94.62-15.88,190.79-25.84,286.86-23.37,102.72,2.63,204.47,28.73,300.34,64.61,79.91,29.91,157,66.71,233.39,104.66,82.75,41.15,165.71,82.11,252.25,114.78q13.88,5.24,27.85,10.24c4.85,1.73,11.14-.61,15.93,1.11-90.73-32.52-177.22-74.16-263.54-116.8-77.31-38.19-154.79-76-235.25-107.27-94.11-36.52-192.33-62-293.19-69.6s-203.17-1-302.93,14.41c-97.58,15-193.72,37-288.63,64.14Q-8.2,671.14-24,675.88c4.73-1.42,11.12,2.55,15.93,1.11Z"/><path class="cls-1" d="M1391.21,662.18c-96.41-30.34-193.13-59.92-290.35-87.56-84.06-23.89-169.71-44.76-256.22-57.51a1414.38,1414.38,0,0,0-313.7-11.26c-75,5.77-148.35,18.87-221.19,37.29-102.88,26-205.14,54.39-306,87.32Q-10.17,635-24,639.63c4.62-1.55,11.23,2.68,15.93,1.11,94.6-31.63,190.38-59.13,286.87-84.38,73.66-19.27,147.21-36.67,223-45.14,101.93-11.4,205.4-11.32,307.11,2,86.55,11.35,172.34,31.44,256.4,54.75,94.92,26.33,189.18,55.34,283.2,84.68l26.79,8.4c5,1.56,11-.43,15.93,1.11Z"/><path class="cls-1" d="M-8.08,570.28C86.8,539.13,183.68,512,281.58,492.12c104.41-21.22,211-35.47,317.68-28.2,91,6.19,181.08,30.19,267.7,57.71,84.52,26.86,168.45,57.73,249.72,93.31,74.94,32.8,148.91,67.41,225.55,96.26q16.47,6.21,33,12.16c4.84,1.74,11.14-.61,15.93,1.11C1307,694.17,1225.29,657.86,1143.76,621c-38.11-17.22-77.09-32.58-116.19-47.39-43.85-16.62-87.91-32.69-132.58-47-88.17-28.26-178.75-52.78-271.26-60.95-50.25-4.44-100.75-6.07-151.14-3.46-51.11,2.64-101.63,10.15-152.06,18.64-106,17.85-210.85,46-313.35,78.28q-15.63,4.93-31.19,10c4.64-1.53,11.21,2.66,15.93,1.11Z"/><path class="cls-1" d="M-8.08,499.82C85.6,470,179.79,439.91,275.32,416.51c93.59-22.93,188.07-39.75,284.65-41.7,60.69-1.23,120.66,4.7,180.91,11.11,50.19,5.34,100.23,11.67,149.77,21.47C960.94,421.3,1030.24,441,1099.82,458c79.35,19.36,156.1,47.5,234.27,71q20.57,6.18,41.19,12.13c5,1.46,11-.32,15.93,1.12q-75.45-21.84-150-46.44c-36.61-12-73.3-23.72-110.72-33-42.38-10.55-84.85-20.71-127.18-31.46-26.21-6.66-52.36-13.45-78.82-19.09C873.14,401.25,821.23,394,769.1,388.33c-52.73-5.73-105.51-11.47-158.51-13.84C504.1,369.72,398.6,383,295,406.94c-97.25,22.51-192.74,52.18-288,82q-15.54,4.86-31,9.8c4.67-1.49,11.18,2.62,15.93,1.11Z"/><path class="cls-1" d="M-8.08,449.79a1536.08,1536.08,0,0,1,277.31-85.32c96.35-20,193.42-36.59,292.2-34.52,51.64,1.09,102.86,7.7,153.82,15.78,39.12,6.2,78.21,12.73,117,20.87,43.19,9.07,86.08,19.48,129,29.67,47.33,11.24,94.7,22.38,141.83,34.45,81.61,20.9,161.76,46.26,244.34,63.43q13.92,2.89,27.87,5.58c5.2,1,10.76.12,15.93,1.11q-71.76-13.83-142.33-33.06c-36.42-9.95-72.55-20.92-109.07-30.54-46.52-12.26-93.34-23.38-140.15-34.51-47.31-11.25-94.57-22.79-142.11-33-85.44-18.38-172.71-32.53-259.92-38.46-52.68-3.58-105.41-3.46-158,1.51-51.21,4.84-102,13.61-152.39,23.69-92.36,18.47-183,42.33-271,76.12Q-4,440.34-24,448.67c4.35-1.81,11.49,3,15.93,1.12Z"/><path class="cls-1" d="M-8.08,410C99.35,378.82,207.26,349,315.86,322.23c56.33-13.9,113-27.52,170.55-35.68,95.45-13.55,192.73-18.16,288.76-8.15,86.79,9.05,173.31,26.8,257.34,50.24,47.6,13.27,94.74,28.16,141.85,43,56.83,17.93,113.58,36.07,170,55.2q15.46,5.24,30.9,10.56c4.88,1.68,11.1-.55,15.93,1.11-106-36.53-213-71.26-320.69-102.51C986.9,311.78,901.19,293,814.74,282.21c-108.91-13.59-218.35-12.73-327.16,1-49.61,6.24-98.51,16.73-147.15,28.18-106.2,25-211.56,53.87-316.48,83.73q-24,6.82-48,13.78c4.76-1.38,11.1,2.51,15.93,1.11Z"/><path class="cls-1" d="M-8.08,348.69c85.37-45,174.31-82.44,264.72-116,93.8-34.82,190.26-60,290.52-65.61,98.46-5.5,198.46,7,294.12,30.3,86.81,21.11,172.25,49.36,256.18,79.85,83,30.13,166.48,57.52,251.67,80.71q13,3.56,26.15,7c5.07,1.34,10.9-.22,15.93,1.11q-132.64-35-261.47-81.77c-85.1-31-171.23-60-259-82.43a1202.86,1202.86,0,0,0-276.35-37.13c-105.59-1.72-209,17.14-308.79,50.89-47.94,16.21-95.09,34.84-141.95,53.91Q71.68,298.8,2.33,334-10.88,340.66-24,347.58c1.4-.74,6.33.52,8,.63,1.85.13,6.28,1.37,8,.48Z"/><path class="cls-1" d="M-8.08,223.77C61.17,155.43,139.79,95,225.53,48.73,273.9,22.63,324,.46,377.22-13.67c52.33-13.9,106.33-21.27,160.39-23.46q29.89-1.2,59.81-.2c3.8.13,7.59.29,11.39.49.66,0,6.55.39,4.89.27,1.6.11,5.6.48,8.13.74,59,5.94,116,20.77,172.31,38.72,52.38,16.69,104,35.22,154.42,57.06,48.29,20.91,95.32,44.2,141.8,68.83,41.82,22.15,83.34,44.85,125.05,67.21,40.18,21.53,80.88,42.07,121,63.8q19.52,10.59,38.91,21.41c4.25,2.37,11.77-1.2,15.93,1.12-44.69-24.93-90.18-48.24-135.39-72.17-42.84-22.67-85.32-46-128.06-68.85-49-26.22-98.41-51.64-149.3-74.12A1574.17,1574.17,0,0,0,827.61,9.64c-55.47-18-111.31-34.26-169.26-42a783.33,783.33,0,0,0-91.7-6.51,793.53,793.53,0,0,0-145.12,11,646.47,646.47,0,0,0-178.3,58.13C159,71.88,81.2,126.12,11.55,189Q-6.62,205.45-24,222.66c.66-.65,6.9.56,8,.63,1.25.09,7.05,1.39,8,.48Z"/><path class="cls-1" d="M-8.08,225.81Q86.27,150.84,180,75.05c26.81-21.69,52.94-44.66,80.64-65.22,28.2-20.93,60.15-37.3,92-51.82A799.17,799.17,0,0,1,516-95.85c53.91-11.59,110.69-18.6,165.28-17.74,29.11.45,57.77,3.62,86.79,7.8,118,17,234.25,54.76,333.67,121.52,48.16,32.34,95.38,65.82,142.43,99.71,29.9,21.54,61.26,41,91.05,62.67q20.4,14.83,40.11,30.59c1.27,1,6.32.52,8,.64s6.67-.56,8,.48c-35.94-28.68-73.83-53.86-111.8-79.69-19.27-13.11-37.7-27.36-56.66-40.89-27.32-19.5-55.06-38.44-82.82-57.31-20.82-14.16-41.63-28.29-63.51-40.8a705.77,705.77,0,0,0-95.83-45.3c-56.8-22-116.08-37.37-176.13-47.33-77.16-12.79-154.42-17-232.2-7.58a806.26,806.26,0,0,0-190,46.95c-41.22,15.69-81.69,34.55-119,58.2C240.44,10.55,220.06,28.48,199.1,45.5Q112.62,115.79,25.49,185.28.77,205-24,224.7c.89-.71,6.72.55,8,.64,1.45.1,6.79,1.42,8,.47Z"/><path class="cls-1" d="M-8.08,70.6C17.21,47.86,41.51,24.08,66.61,1.15a744.91,744.91,0,0,1,82.87-65.34c53.77-36.65,111.93-66.69,172.25-91,79.87-32.19,164.33-55.67,249.75-67.3C680-237.27,792-224.72,896.94-195.14c101.79,28.68,199.43,74.31,286.3,134.68,25.16,17.49,49.83,36.17,72.08,57.3A155.5,155.5,0,0,1,1271,13.62a506.87,506.87,0,0,0,67.6,71.18q17.65,15.3,36.68,28.94c1.42,1,6.21.51,8,.63s6.53-.55,8,.48A511.93,511.93,0,0,1,1308,40.06c-9.72-10.88-18.13-22.94-28.15-33.52-18.62-19.66-40.43-36.6-62.16-52.62a913.75,913.75,0,0,0-115.57-72.11A971.67,971.67,0,0,0,939-186.27a921.57,921.57,0,0,0-199-39c-56.33-4.69-113.45-6.18-169.76-.12-24.59,2.64-49,6.95-73.26,11.87a1108,1108,0,0,0-142.47,39C294.35-153.67,236-127.54,181-95.33A800.65,800.65,0,0,0,93.09-35.78c-25,19.5-47.88,41-70.89,62.72Q-.64,48.5-24,69.49c.75-.68,6.82.55,8,.63,1.33.1,6.94,1.41,8,.48Z"/></svg>');
  // mask-size: cover;
  // mask-position: left;
  // background: linear-gradient(-45deg, #ffffff, #38183D, #ffffff, rgb(152, 65, 165));
  // background-size: 400% 400%;
  // animation: gradient 15s ease infinite;

  // background: #9D50BB;  /* fallback for old browsers */
  // background: linear-gradient(to right, #6E48AA, #9D50BB); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */

  &.animate {
    animation: line 10s ease-in-out;
  }

}

@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@keyframes line {
  0% {
    width: 0;
    left: 0;
    mask-position: left;
    transform-origin: left;
  }

  25% {
    width: 100%
  }

  50% {
    width: 0;
    right: 0;
    mask-position: right;
  }

  75% {
    width: 100%;
  }

  100% {
    width: 0;
    right: initial;
    mask-position: left;
  }
}

// html {
//   font-size: 14px;
// }
body {
  background-color: #441a46;
}

#app {
  font-family: Cairo, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background-color: #dfdfdf;

  &.dark {
    background-color: #441a46;
      color: #ffffff;

    .logo, .hamburger, .background, .btn:not(.btn--white) {
      filter: brightness(0) invert(1);
    }
  }
}

.logo {
  position: fixed;
  top: 0;
  right: 0;
  margin: 2rem;
  z-index: 10;

  img {
    width: 100px;
  }
}

.hamburger {
  position: fixed;
  top: 0;
  left: 0;
  margin: 2rem;
  cursor: pointer;
  z-index: 10;

  .hamburger__inner {
    width: 2.5rem;
    height: 2.5rem;
    line-height: .8;
    overflow: hidden;

    .hamburger-line {
      display: inline-block;
      position: relative;
      width: 100%;
      height: 3px;
      background-color: black;
      transition: left .2s ease-in-out;

      &:nth-child(1) {
        left: 50%;
      }
      &:nth-child(3) {
        left: -50%;
      }
    }

    &:hover {
      .hamburger-line {
        &:nth-child(1), &:nth-child(3) {
          left: 0;
        }
      }
    }
  }
}

section {
  @media screen and (min-width: 960px) {
    height: 100vh;
  }

  &:not(:last-child) {
    margin-bottom: 8rem;
  }

  &:last-child {
    padding-bottom: 8rem;
  }
}

.big-title {
  position: relative;
  z-index: 2;
  // margin: 2rem 0;
  padding: 2rem 2rem;
  // font-family: Montserrat Bold;
  line-height: 1;

  &.big-title--no-p {
    padding: 0;
  }

  @media screen and (min-width: 640px) {
      font-size: 5rem;
  }
  @media screen and (min-width: 960px) {
      padding-right: 6.5rem;
      font-size: 6rem;
  }

  &.big-title--pl {
    @media screen and (min-width: 960px) {
      padding-right: 11rem;
    }
  }
}

.d-flex {
  display: flex;

  &.align-center {
    align-items: center;
  }
}

p {
  line-height: 1.5;
  margin-bottom: 2rem;
}

a, p {
  font-size: 1rem;
}

.btn {
  display: inline-block;
  // margin-top: 1rem;
  padding: .5rem 1rem;
  background-color: transparent;
  color: #441a46;
  text-align: center;
  // font-family: Montserrat;
  font-weight: 700;
  font-size: 1.15rem;
  border-radius: 6px;
  overflow: hidden;
  outline: none;
}

.btn--white {
  background-color: #fff;
}

.btn--primary {
  background-color: #441a46;
  color: #441a46;

  &.btn--outline {
    background-color: transparent;
    border: #441a46 3px solid;
    color: #441a46;
  }
}

.wrapper {
  margin: 0 auto;
  max-width: 1150px;
  padding: 6rem 2rem 2rem;
}
</style>
